var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShadow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1144.76,
    height: 154.119,
    viewBox: "0 0 1144.76 154.119",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1829.76 -6529.198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1698.652,6575.182c-50.683,3.874-109.385,9.907-118.778,22.322-6.119,8.089,13.721,16.556,43.6,20.735,14.585,2.04,32.487,3.475,40.117,7.057,11.855,5.565-9.447,11.947-31.941,15.183s-49.93,5.8-60.17,11.545c-6.749,3.785-4.1,8.193,2.578,11.984,24.5,13.9,95.947,19.992,159.484,19.249s123.8-6.606,186.122-9.624c214.029-10.365,438.433,13.16,652.094,2.38,33.249-1.678,66.739-4.3,92.418-9.579,28.944-5.947,45.38-14.918,47.859-23.973,2.365-8.64-10.567-18.367-43.217-22.261-19.081-2.275-41.883-2.182-62.6-.944-13.228.79-45.472-2.293-49.425-5.385-4.157-3.251,5.314-6.608,16.179-8.827,22.094-4.511,28.593-4.021,48.658-9.036,19.31-4.827,27.437-12.02,20.884-18.485s-27.585-12-54.041-14.225c-67.427-5.669-140.889,9.785-209.835,5.257-5.119-.337-10.505-.855-13.2-1.939-2.631-1.058-2.028-2.4-.519-3.576,8.447-6.575,41.254-10.761,42.691-17.625.781-3.732-8.533-7.223-20.276-9.718-80.685-17.146-79.058,4.471-279.859,9.687C-1425.478,6548.908-1563,6564.814-1698.652,6575.182Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shadow.e59b3b5b.svg";
export { ForwardRef as ReactComponent };